import { render, staticRenderFns } from "./NewConsolidation.vue?vue&type=template&id=54aff4b7&scoped=true"
import script from "./NewConsolidation.vue?vue&type=script&lang=js"
export * from "./NewConsolidation.vue?vue&type=script&lang=js"
import style0 from "./NewConsolidation.vue?vue&type=style&index=0&id=54aff4b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aff4b7",
  null
  
)

export default component.exports